import { Anchor, Fish, PackageCheck, Ship } from "lucide-react";
export default function TrustBar() {
  const trustPoints = [{
    icon: Fish,
    text: "Wild-Caught Seafood"
  }, {
    icon: Anchor,
    text: "Responsibly Harvested"
  }, {
    icon: PackageCheck,
    text: "Expertly Cut & Packed"
  }, {
    icon: Ship,
    text: "Delivered with Care"
  }];
  return <section id="trust-bar" className="bg-background border-b border-border py-6 md:py-8">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-6 sm:gap-y-8 lg:gap-y-0">
          {trustPoints.map((point, i) => {
          const Icon = point.icon;
          return <div key={i} data-index={i} className={`flex items-center justify-center gap-4 px-4 ${i !== 0 ? "lg:border-l lg:border-border" : ""}`}>
                <Icon className="w-5 h-5 md:w-6 md:h-6 text-primary shrink-0" strokeWidth={1.5} />
                <span className="font-mono text-xs md:text-sm uppercase tracking-widest text-foreground font-medium text-center sm:text-left">
                  {point.text}
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}